import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@cdl/heartbeat-react';
import * as colors from '../../utils/colors';
import * as ruler2dActions from '../actions/ruler2d.actions';
import { useRuler2dDimensions } from '../hooks/useRuler2dDimensions';
import { useEventTimestamp } from '../../plot/hooks/useEventTimestamp';
import { useEventVoltage } from '../../plot/hooks/useEventVoltage';
import { isMovingRuler2dSelector } from '../selectors/ruler2d.selectors';

export const Ruler2dSquare: React.FC = () => {
  const dispatch = useDispatch();
  const { x, y, height, width } = useRuler2dDimensions();
  const isMoving = useSelector(isMovingRuler2dSelector);
  const getTimestamp = useEventTimestamp();
  const getVoltage = useEventVoltage();

  const startMoving = (event: React.MouseEvent<SVGRectElement>) => {
    event.preventDefault();
    if (event.button !== 0) {
      return;
    }
    const timestamp = getTimestamp(event);
    const voltage = getVoltage(event);
    dispatch(ruler2dActions.setMoving({ timestamp, voltage }));
  };

  return (
    <Box
      data-testid='ruler2d-main'
      as='rect'
      width={width}
      height={height}
      x={x}
      y={y}
      fill={colors.rulerBackground}
      stroke='neutral.300'
      strokeWidth='0.125rem'
      onMouseDown={startMoving}
      cursor={isMoving ? 'grabbing' : 'grab'}
    />
  );
};
